/**
 * @generated SignedSource<<8dc21b14bc084bf60aab723e67d3f501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceSignalSchedulePublishMutation$variables = {
  archiveAt?: string | null;
  id: string;
};
export type WorkspaceSignalSchedulePublishMutation$data = {
  readonly signalWorkspace: {
    readonly publish: {
      readonly status: WorkspaceSignalStatus;
    };
  };
};
export type WorkspaceSignalSchedulePublishMutation = {
  response: WorkspaceSignalSchedulePublishMutation$data;
  variables: WorkspaceSignalSchedulePublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archiveAt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "archiveAt",
    "variableName": "archiveAt"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalSchedulePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "publish",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalSchedulePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "publish",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "feee7085140fafc7be8359fab454d400",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalSchedulePublishMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalSchedulePublishMutation(\n  $id: ID!\n  $archiveAt: String\n) {\n  signalWorkspace(id: $id) {\n    publish(archiveAt: $archiveAt) {\n      status\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b71a18d19d948b2687dbcf66e3e24be8";

export default node;
